'use client'

import { useContext, useEffect, useRef } from 'react'
import { createConsumer, ChannelNameWithParams } from '@rails/actioncable'

import { useSession } from '@marketplace-web/shared/session'
import { ConversationListContext } from '@marketplace-web/domain/core-conversation'
import { useSystemConfiguration } from '@marketplace-web/shared/system-configuration'

const NOTIFICATION_CHANNEL = 'InboxChannel'

type Props = {
  url: string
}

type InboxNotificationsResp = {
  event: string
  conversation_id: string
}

const InboxNotifications = ({ url }: Props) => {
  const { portal } = useSystemConfiguration()
  const userId = useSession().user?.id
  const { websocketUserId, updateConversation } = useContext(ConversationListContext)
  const updateConversationRef = useRef(updateConversation)

  const handleMessage = (props: InboxNotificationsResp) => {
    updateConversationRef.current({ id: props.conversation_id })
  }

  useEffect(() => {
    updateConversationRef.current = updateConversation
  }, [updateConversation])

  useEffect(() => {
    const cable = createConsumer(url)

    if (websocketUserId) {
      const channel: ChannelNameWithParams = {
        channel: NOTIFICATION_CHANNEL,
        country: portal,
        user_id: userId,
        websocket_user_id: websocketUserId,
      }

      cable.subscriptions.create(channel, { received: handleMessage })
    }

    return () => cable.disconnect()
  }, [url, websocketUserId, userId, portal])

  return null
}

export default InboxNotifications
